export default "__VITE_ASSET__c40308c7__"